import { VenueTemplate } from '../types/venueTemplate';
import { Plan, VenueHours, VenueMealPeriod } from '../types/plan';
import { PropertyType } from '../types/property';
import { MealPeriodTranslation } from '../types/translation';
import { hasOwnProperty } from '../lib/utils';
/**
 * TODO: Currently hardcoding VV (Apollo) and Land meal periods. This should come from a Database
 * instead once we implement venue attributes
 *
 *
 */

export interface BrandMealPeriod {
  _id: string;
  code: string;
  name: string;
  color: string;
  type: PropertyType;
}

export interface VenueDispositionWithTemplate {
  template: VenueTemplate;
  venueHours: VenueHours[][];
  venueMealperiods: VenueMealPeriod[][];
}

export const venueDispositionsMapper = (
  vts: VenueTemplate[],
  plan: Plan
): VenueDispositionWithTemplate[] => {
  const venueDispositions: { [key: string]: VenueDispositionWithTemplate } = {};
  plan.venueData.forEach(vd => {
    if (!venueDispositions[vd.template]) {
      venueDispositions[vd.template] = {
        template: vts.find(vt => vt._id === vd.template)!,
        venueHours: [vd.hours],
        venueMealperiods: [vd.mealPeriods],
      };
    } else {
      venueDispositions[vd.template].venueHours.push(vd.hours);
      venueDispositions[vd.template].venueMealperiods.push(vd.mealPeriods);
    }
  });

  const venueDispositionWithTemplate: VenueDispositionWithTemplate[] = [];
  Object.keys(venueDispositions).forEach(key => {
    venueDispositionWithTemplate.push(venueDispositions[key]);
  });

  return venueDispositionWithTemplate;
};

export const singleVenueDispositionMapper = (
  plan: Plan,
  vt: VenueTemplate
): VenueDispositionWithTemplate => {
  const match = plan.venueData.find(vd => vd.template === vt._id)!;
  return {
    template: vt,
    venueMealperiods: [match.mealPeriods],
    venueHours: [match.hours],
  };
};

export function translateMealPeriod<T extends VenueMealPeriod | BrandMealPeriod>(
  mealPeriod: T,
  translation?: MealPeriodTranslation,
  lang?: string
): T | undefined {
  if (!translation || !lang) return undefined;
  const { transforms: transforms } = translation;

  if (!transforms || !hasOwnProperty(transforms, lang) || !transforms[lang].active) {
    return undefined;
  }

  return {
    ...mealPeriod,
    name: transforms[lang].delta.name,
    _lang: lang,
  };
}
